(() => {
  const BIS_SELECTOR = '.BIS_trigger';

  document.querySelectorAll('.BIS_trigger').forEach((btn) => {
    const container = btn.closest('.product-form-buttons');
    const addToCartBtn = container?.querySelector('.add-to-cart-button');
    if (!addToCartBtn) return;
  
    const bisVisible = getComputedStyle(btn).display !== 'none';
    addToCartBtn.style.display = bisVisible ? 'none' : '';
  });

  const syncButton = (btn, variant) => {
    if (!variant) return;
    const productId = btn.dataset.productId;
    if (productId && variant.product_id && String(variant.product_id) !== String(productId)) return;

    const showBis = !variant.available;
    btn.dataset.variantId = variant.id;
    btn.style.display = showBis ? '' : 'none';

    const container = btn.closest('.product-form-buttons');
    const addToCartBtn = container?.querySelector('.add-to-cart-button');
    if (addToCartBtn) addToCartBtn.style.display = showBis ? 'none' : '';
  };

  document.addEventListener('variant:update', (event) => {
    const variant = event?.detail?.resource;
    const eventProductId = event?.detail?.data?.productId;
    if (!variant) return;

    document.querySelectorAll(BIS_SELECTOR).forEach((btn) => {
      const productId = btn.dataset.productId;
      if (productId && eventProductId && String(eventProductId) !== String(productId)) return;
      syncButton(btn, variant);
    });
  });

  // ✅ Close quick add when BIS clicked
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(BIS_SELECTOR);
    if (!btn) return;

    const dialog = btn.closest('quick-add-dialog');
    if (!dialog) return;

    const closeButton = dialog.querySelector('[ref="closeButton"]');
    if (closeButton instanceof HTMLElement) {
      closeButton.click();
    }
  });

})();